import { Component, OnInit, Input } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { StockFilterService } from 'src/app/features/stock-screener/services/stock-filter.service';

interface DocumentType {
  label: string;
  year: number;
  quarter: number;  // Quarter of the record (1, 2, 3, or 4)
  value: number;
}

@Component({
    selector: 'app-balancesheet',
    templateUrl: './balancesheet.component.html',
    styleUrls: ['./balancesheet.component.scss'],
    standalone: false
})
export class BalancesheetComponent implements OnInit {
  _isAnnual: boolean = true;
  period: number[] = [2020, 2021, 2022, 2023, 2024];
  setLoadingState: boolean = true;

  page_num: number = 1;
  annualData: any[] = [];
  quarterlyData: any[] = [];
  specialArray: any[] = [];

  @Input() chartKey: string = '';

  constructor(
    private financialService: StockFilterService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Clear any existing data
    this.annualData = [];
    this.quarterlyData = [];

    // Set initial state
    this.setLoadingState = true;
    this.isAnnual = true; // This will trigger the setter and fetch annual data
  }

  changePeriod(periodValue: boolean): void {
    // Only update if the value actually changed to prevent duplicate fetches
    if (this._isAnnual !== periodValue) {
      this.setLoadingState = true;

      // Reset data arrays before changing period to prevent data accumulation
      if (periodValue) {
        this.quarterlyData = []; // Clear quarterly data when switching to annual
      } else {
        this.annualData = []; // Clear annual data when switching to quarterly
      }

      this.isAnnual = periodValue;  // This will trigger the setter
      // console.log("Period changed to:", periodValue ? "Annual" : "Quarterly");
    }
  }

  get isAnnual(): boolean {
    return this._isAnnual;
  }

  set isAnnual(value: boolean) {
    this._isAnnual = value;

    // Call specific function based on value
    if (value) {
      this.getAnnualData();
    } else {
      this.getQuarterlyData();
    }
  }

  getAnnualData() {
    // Only fetch if we don't already have data
    if (this.annualData.length === 0) {
      // console.log('Fetching annual data...');
      this.getNewActualAnnualData(this.chartKey, "annual", this.page_num, this.annualData);
    } else {
      // Data already exists, just update UI
      this.setLoadingState = false;
      this.cd.detectChanges();
    }
  }

  getQuarterlyData() {
    // Only fetch if we don't already have data
    if (this.quarterlyData.length === 0) {
      // console.log('Fetching quarterly data...');
      this.getNewActualQuarterlyData(
        this.chartKey,
        'quarterly',
        this.page_num,
        this.quarterlyData
      );
    } else {
      // Data already exists, just update UI
      this.setLoadingState = false;
      this.cd.detectChanges();
    }
  }

//      async getActualAnnualData(ticker: string, freq: string, period: number[], page_num: number, targetArray: any[]) {
//       try {
//           // Define priority labels in desired order
//           const topLabels = [
//             "Net income",
//             "Adjustments to Reconcile Net Income (Loss) to Cash Provided by (Used in) Operating Activities",
//             "Depreciation and amortization",
//             "Share-based compensation expense",
//             "Other",
//             "Changes in Operating Assets & Liabilities",
//             "Accounts receivable, net",
//             "Vendor non-trade receivables",
//             "Inventories",
//             "Other current and non-current liabilities",
//             "Cash generated by operating activities",
//             "Investing Activities",
//             "Purchases of marketable securities",
//             "Proceeds from maturities of marketable securities",
//             "Proceeds from sales of marketable securities",
//             "Payments for acquisition of property, plant and equipment",
//             "Cash generated by operating activities",
//             "Financial Activities",
//             "Payments for taxes related to net share settlement of equity awards",
//             "Payments for dividends and dividend equivalents",
//             "Repurchases of common stock",
//             "Proceeds from issuance of term debts, net",
//             "Proceeds from commercial paper, net",
//              "Cash Generated by Investing Activities",

//         ];

//           let allData: any[] = [];
//           let hasMoreData = true;

//           while (hasMoreData) {
//               const response = await this.financialService.getAnnualIncomeStatement(ticker, freq, period, "bs", page_num, "asc");

//               if (response && response.hits && response.hits.length > 0) {
//                   allData.push(...response.hits);

//                   if (response.hits.length < 100) {
//                       hasMoreData = false;
//                   } else {
//                       page_num++;
//                   }
//               } else {
//                   hasMoreData = false;
//               }
//           }

//           interface DocumentType {
//               label: string;
//               year: number;
//               value: number;
//           }

//           const labelMap = new Map<string, Record<number, number>>();

//           const processDocument = (hit: { document: DocumentType }) => {
//               const doc = hit.document;
//               const { label, year, value } = doc;

//               if (!labelMap.has(label)) {
//                   labelMap.set(label, { [year]: value });
//               } else {
//                   const labelData = labelMap.get(label)!;
//                   labelData[year] = value;
//                   labelMap.set(label, labelData);
//               }
//           };

//           allData.forEach(processDocument);

//           // Convert Map to array and sort based on priority labels
//           const result = Array.from(labelMap.entries())
//               .map(([label, data]) => ({
//                   label,
//                   data
//               }))
//               .sort((a, b) => {
//                   const indexA = topLabels.indexOf(a.label);
//                   const indexB = topLabels.indexOf(b.label);

//                   // If both labels are in topLabels, sort by their order
//                   if (indexA !== -1 && indexB !== -1) {
//                       return indexA - indexB;
//                   }
//                   // If only a is in topLabels, it comes first
//                   if (indexA !== -1) {
//                       return -1;
//                   }
//                   // If only b is in topLabels, it comes first
//                   if (indexB !== -1) {
//                       return 1;
//                   }
//                   // If neither is in topLabels, maintain their original order
//                   return 0;
//               });

//           const filteredResult = result.filter(item => item.data && Object.keys(item.data).length > 0);

//           this.setLoadingState = false;
//           targetArray.push(...filteredResult);

//           return filteredResult;

//       } catch (error) {
//           this.setLoadingState = false;
//           throw error;
//       }
//   }


  async getNewActualAnnualData(
    ticker: string,
    freq: string,
    page_num: number,
    targetArray: any[]
  ) {
    try {
      // Define the priority labels in the desired order
      const topLabels = [
         // Assets
  'totalAssets',                     // Total Assets
  'currentAssets',
  'cashShortTermInvestments',        // Cash & Short-Term Investments
  'cash',                            // Cash
  'cashEquivalents',                 // Cash Equivalents
  'shortTermInvestments',            // Short-Term Investments
  'accountsReceivables',             // Accounts Receivable
  'inventory',                       // Inventory
  'otherCurrentAssets',              // Other Current Assets
  'propertyPlantEquipment',          // Property, Plant & Equipment
  'accumulatedDepreciation',         // Accumulated Depreciation
  'longTermInvestments',             // Long-Term Investments
  'noteReceivableLongTerm',          // Long-Term Notes Receivable
  'otherLongTermAssets',             // Other Long-Term Assets
  'goodwill',                        // Goodwill
  'intangiblesAssets',               // Intangible Assets
  // Liabilities and Equity
  'totalLiabilities',                // Total Liabilities
  'currentLiabilities',
  'accountsPayable',                 // Accounts Payable
  'accruedLiability',                // Accrued Liabilities
  'shortTermDebt',                   // Short-Term Debt
  'currentPortionLongTermDebt',      // Current Portion of Long-Term Debt
  'otherCurrentliabilities',         // Other Current Liabilities
  'longTermDebt',                    // Long-Term Debt
  'netDebt',                         // Net Debt
  'otherLiabilities',                // Other Liabilities
  'totalDebt',                       // Total Debt
  'liabilitiesShareholdersEquity',   // Total Liabilities & Shareholders’ Equity
  'totalEquity',                     // Total Shareholders' Equity
  'minorityInterest',                // Minority Interest (Non-Controlling Interest)
  'commonStock',                     // Common Stock
  'additionalPaidInCapital',         // Additional Paid-In Capital
  'retainedEarnings',                // Retained Earnings
  'otherEquity',                     // Other Equity
  'sharesOutstanding'                // Shares Outstanding
      ];

      let allData: any[] = [];
      let hasMoreData = true;

      // Fetch data until there are no more pages (assuming less than 100 hits means last page)
      while (hasMoreData) {
        const response = await this.financialService.getNewIncomeData(ticker, freq, page_num);
      //   console.log("Response is", response);

        if (response && response.hits && response.hits.length > 0) {
          allData.push(...response.hits);
          if (response.hits.length < 100) {
            hasMoreData = false;
          } else {
            page_num++;
          }
        } else {
          hasMoreData = false;
        }
      }

      // Build a map where the key is the label (only for topLabels) and the value is an object mapping year to value.
      const labelMap = new Map<string, Record<string, number>>();

      // Process each document/hit
      allData.forEach((hit: any) => {
        const doc = hit.document;
        const year = doc.year;
        if (!year) return; // Skip if no year is provided

        // Only process the labels specified in topLabels
        topLabels.forEach(label => {
          if (doc[label] !== undefined && doc[label] !== "" && doc[label] !== null) {
            const value = parseFloat(doc[label]);
            if (!isNaN(value)) {
              if (!labelMap.has(label)) {
                labelMap.set(label, { [year]: value });
              } else {
                const existingData = labelMap.get(label)!;
                existingData[year] = value;
                labelMap.set(label, existingData);
              }
            }
          }
        });
      });

      // Convert the Map into an array, preserving the order defined in topLabels
      const result = Array.from(labelMap.entries())
        .map(([label, data]) => ({ label, data }))
        .sort((a, b) => topLabels.indexOf(a.label) - topLabels.indexOf(b.label));

      // Filter out any entries that have no data (just in case)
      const filteredResult = result.filter(item => item.data && Object.keys(item.data).length > 0);

      this.setLoadingState = false;
      targetArray.push(...filteredResult);
      // console.log("target array is ", targetArray);

      return filteredResult;
    } catch (error) {
      this.setLoadingState = false;
      throw error;
    }
  }



  async getNewActualQuarterlyData(
   ticker: string,
   freq: string,
   page_num: number,
   targetArray: any[]
) {
   try {
      let allData: any[] = [];
      let hasMoreData = true;

      while (hasMoreData) {
         const response = await this.financialService.getNewIncomeData(
            ticker,
            freq,
            page_num
         );
         // console.log('Response 2 is', response);

         if (response?.hits?.length > 0) {
            allData.push(...response.hits);
            hasMoreData = response.hits.length >= 100;
            if (hasMoreData) page_num++;
         } else {
            hasMoreData = false;
         }
      }

      const labelMap = new Map<string, Record<string, number>>();
      const topLabels = [
         // Assets
  'totalAssets',                     // Total Assets
  'currentAssets',
  'cashShortTermInvestments',        // Cash & Short-Term Investments
  'cash',                            // Cash
  'cashEquivalents',                 // Cash Equivalents
  'shortTermInvestments',            // Short-Term Investments
  'accountsReceivables',             // Accounts Receivable
  'inventory',                       // Inventory
  'otherCurrentAssets',              // Other Current Assets
  'propertyPlantEquipment',          // Property, Plant & Equipment
  'accumulatedDepreciation',         // Accumulated Depreciation
  'longTermInvestments',             // Long-Term Investments
  'noteReceivableLongTerm',          // Long-Term Notes Receivable
  'otherLongTermAssets',             // Other Long-Term Assets
  'goodwill',                        // Goodwill
  'intangiblesAssets',               // Intangible Assets
  // Liabilities and Equity
  'totalLiabilities',                // Total Liabilities
  'currentLiabilities',
  'accountsPayable',                 // Accounts Payable
  'accruedLiability',                // Accrued Liabilities
  'shortTermDebt',                   // Short-Term Debt
  'currentPortionLongTermDebt',      // Current Portion of Long-Term Debt
  'otherCurrentliabilities',         // Other Current Liabilities
  'longTermDebt',                    // Long-Term Debt
  'netDebt',                         // Net Debt
  'otherLiabilities',                // Other Liabilities
  'totalDebt',                       // Total Debt
  'liabilitiesShareholdersEquity',   // Total Liabilities & Shareholders’ Equity
  'totalEquity',                     // Total Shareholders' Equity
  'minorityInterest',                // Minority Interest (Non-Controlling Interest)
  'commonStock',                     // Common Stock
  'additionalPaidInCapital',         // Additional Paid-In Capital
  'retainedEarnings',                // Retained Earnings
  'otherEquity',                     // Other Equity
  'sharesOutstanding'                // Shares Outstanding
      ];

      allData.forEach((hit: any) => {
         const doc = hit.document;
         if (!doc?.period) return; // Skip if period is missing
         if (/^\d{4}$/.test(String(doc.period))) return; // Skip annual records

         const quarterLabel = this.formatQuarterLabel(doc.period);
         if (!quarterLabel) return;

         topLabels.forEach((label) => {
            const value = parseFloat(doc[label]);
            if (!isNaN(value)) {
               if (!labelMap.has(label)) {
                  labelMap.set(label, { [quarterLabel]: value });
               } else {
                  labelMap.get(label)![quarterLabel] = value;
               }
            }
         });
      });

      const result = Array.from(labelMap.entries()).map(([label, data]) => ({
         label,
         data,
      }));

      this.setLoadingState = false;

      // Directly updating the reference instead of modifying the array
      this.quarterlyData = [...result];
      // console.log('Updated quarterlyData:', this.quarterlyData);

      // Manually trigger change detection
      this.cd.detectChanges();
   } catch (error) {
      this.setLoadingState = false;
      // console.error('Error fetching quarterly data:', error);
   }
}

formatQuarterLabel(dateString: string): string | null {
   if (!dateString) return null;

   const date = new Date(dateString);
   if (isNaN(date.getTime())) {
      // console.error('Invalid date:', dateString);
      return null;
   }

   const month = date.getMonth() + 1;
   const year = date.getFullYear().toString().slice(-2);
   const quarter = Math.ceil(month / 3);

   return `Q${quarter}'${year}`;
}



  async getActualQuarterlyData(ticker: string, freq: string, period: number[], page_num: number, targetArray: any[]) {
   try {
      const topLabels = [
         "Net income",
         "Adjustments to Reconcile Net Income (Loss) to Cash Provided by (Used in) Operating Activities",
         "Depreciation and amortization",
         "Share-based compensation expense",
         "Other",
         "Changes in Operating Assets & Liabilities",
         "Accounts receivable, net",
         "Vendor non-trade receivables",
         "Inventories",
         "Other current and non-current liabilities",
         "Cash generated by operating activities",
         "Investing Activities",
         "Purchases of marketable securities",
         "Proceeds from maturities of marketable securities",
         "Proceeds from sales of marketable securities",
         "Payments for acquisition of property, plant and equipment",
         "Cash generated by operating activities",
         "Financial Activities",
         "Payments for taxes related to net share settlement of equity awards",
         "Payments for dividends and dividend equivalents",
         "Repurchases of common stock",
         "Proceeds from issuance of term debts, net",
         "Proceeds from commercial paper, net",
          "Cash Generated by Investing Activities",

     ];

       let allData: any[] = [];
       let hasMoreData = true;

       while (hasMoreData) {
           const response = await this.financialService.getAnnualIncomeStatement(ticker, freq, period, "bs", page_num, "desc");

           if (response && response.hits && response.hits.length > 0) {
               allData.push(...response.hits);

               if (response.hits.length < 100) {
                   hasMoreData = false;
               } else {
                   page_num++;
               }
           } else {
               hasMoreData = false;
           }
       }

       interface DocumentType {
           label: string;
           year: number;
           quarter: number;
           value: number;
       }

       const labelMap = new Map<string, Record<number, Record<number, number>>>();

       allData.forEach((hit: { document: DocumentType }) => {
           const doc = hit.document;
           const { label, year, quarter, value } = doc;

           if (!labelMap.has(label)) {
               labelMap.set(label, {});
           }

           const labelData = labelMap.get(label)!;

           if (!labelData[year]) {
               labelData[year] = {};
           }

           labelData[year][quarter] = value;
       });

       // Convert to array and process quarterly data
       const result = Array.from(labelMap.entries()).map(([label, data]) => {
           const quarterLabels: string[] = [];
           const quarterData: Record<string, number> = {};

           const sortedYears = Object.keys(data).map(Number).sort((a, b) => b - a);

           for (const year of sortedYears) {
               const sortedQuarters = Object.keys(data[year]).map(Number).sort((a, b) => b - a);

               for (const quarter of sortedQuarters) {
                   const quarterLabel = `Q${quarter}'${year.toString().slice(-2)}`;
                   quarterLabels.push(quarterLabel);
                   quarterData[quarterLabel] = data[year][quarter];

                   if (quarterLabels.length >= 5) {
                       break;
                   }
               }

               if (quarterLabels.length >= 5) {
                   break;
               }
           }

           return { label, data: quarterData };
       })
       // Sort based on topLabels priority
       .sort((a, b) => {
           const indexA = topLabels.indexOf(a.label);
           const indexB = topLabels.indexOf(b.label);

           // If both labels are in topLabels, sort by their order
           if (indexA !== -1 && indexB !== -1) {
               return indexA - indexB;
           }
           // If only a is in topLabels, it comes first
           if (indexA !== -1) {
               return -1;
           }
           // If only b is in topLabels, it comes first
           if (indexB !== -1) {
               return 1;
           }
           // If neither is in topLabels, maintain their original order
           return 0;
       });

       const filteredResult = result.filter(item => item.data && Object.keys(item.data).length > 0);

       this.setLoadingState = false;
       targetArray.push(...filteredResult);

       return filteredResult;

   } catch (error) {
       this.setLoadingState = false;
       throw error;
   }
}







    transformData(arrays: any[][]): any[] {
     const resultMap = new Map<string, any>();

     for (const array of arrays) {
       for (const doc of array) {
         const label = doc.label;
         const year = doc.year;
         const value = doc.value;

         if (!resultMap.has(label)) {
           resultMap.set(label, { label });
         }

         resultMap.get(label)[year] = value;
       }
     }

     return Array.from(resultMap.values());
   }
}
